"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Body1Stronger: function() {
        return _Body1Stronger.Body1Stronger;
    },
    body1StrongerClassNames: function() {
        return _useBody1StrongerStylesstyles.body1StrongerClassNames;
    }
});
const _Body1Stronger = require("./Body1Stronger");
const _useBody1StrongerStylesstyles = require("./useBody1StrongerStyles.styles");
